export default __webpack_public_path__ + "static/media/skin-in-the-game-banner-mob.89c0ec19.jpg";